<mat-card mat-dialog-content class="sdp-force-password-container">
	<div class="sdp-force-password-inner-container">
		<h3>{{ "sdp.welcome.to" | translate }} {{ "application.title" | translate }}</h3>
		<div>{{ "forcePasswordChange.description" | translate }}.</div>
		<form [formGroup]="resetPasswordForm" (ngSubmit)="submit()" novalidate>
			<div class="sdp-form-control">
				<sdp-icon [icon]="lockIcon"></sdp-icon>
				<mat-form-field class="sdp-force-password-input-container">
					<input matInput placeholder="{{ 'form.label.password' | translate }}" type="{{ passwordType }}" formControlName="password">
					<mat-error *ngIf="resetPasswordForm.controls['password'].hasError('required') && isResetSubmitted">{{ "error.message.password" | translate }}</mat-error>
				</mat-form-field>

				<div class="sdp-force-password-show-container" [class.sdp-text-input]="passwordType==='text'">
					<sdp-icon [icon]="passwordIcon" (click)="passwordType = passwordType==='text'?'password':'text'"></sdp-icon>
				</div>
				<div class="sdp-password-strength-container">
					<ng2-password-strength-bar [passwordToCheck]="resetPasswordForm.get('password')!.value" barLabel="{{ 'password.strength.label' | translate }}"></ng2-password-strength-bar>
				</div>
			</div>
			<div class="sdp-form-control" *ngIf="errMessage && errMessage.length > 0">
				<mat-card class="sdp-force-password-error">{{ errMessage }}</mat-card>
			</div>
			<div class="sdp-form-buttons-container">
				<button mat-raised-button color="primary" type="submit">{{ "forcePasswordChange.button.text" | translate }}</button>
			</div>
		</form>
	</div>
</mat-card>